import AuthWrapper from "./auth-wrapper";

export default AuthWrapper;
